module.exports = __webpack_public_path__ + "media/images/loading1-1eb44317a0d638024d88b5bc35515267.gif";